import React from "react";
import { PageLayout } from "./Layout";
import "./i18n";
import { InfoProvider } from "./context/InfoContext";

const App = () => {
  return (
    <div>
      <InfoProvider>
        <PageLayout />
      </InfoProvider>
    </div>
  );
};

export default App;
